import { ComponentType } from 'react';
import clsx from 'clsx';

import { SvgWrapperProps } from 'components/svgs/SvgWrapper/SvgWrapper';
import { AltaSosSvg } from 'components/svgs/AltaSosSvg';
import { AltaVisitorSvg } from 'components/svgs/AltaVisitorSvg';
import { AltaAccessSvg } from 'components/svgs/AltaAccessSvg';
import { AltaMailroomSvg } from 'components/svgs/AltaMailroomSvg';
import { AltaProtectSvg } from 'components/svgs/AltaProtectSvg';
import { AltaVideoSvg } from 'components/svgs/AltaVideoSvg';

import {
  ACCESS_NATIVE_APP_ID,
  MAILROOM_NATIVE_APP_ID,
  PROTECT_NATIVE_APP_ID,
  VIDEO_NATIVE_APP_ID,
  SOS_NATIVE_APP_ID,
  VISITOR_NATIVE_APP_ID,
} from '../../../../constants/native-apps';

import './NativeAppIcon.scss';

const NATIVE_APP_ICONS: Record<
  number,
  ComponentType<Omit<SvgWrapperProps, 'children'>>
> = {
  [ACCESS_NATIVE_APP_ID]: AltaAccessSvg,
  [MAILROOM_NATIVE_APP_ID]: AltaMailroomSvg,
  [PROTECT_NATIVE_APP_ID]: AltaProtectSvg,
  [VIDEO_NATIVE_APP_ID]: AltaVideoSvg,
  [SOS_NATIVE_APP_ID]: AltaSosSvg,
  [VISITOR_NATIVE_APP_ID]: AltaVisitorSvg,
};

interface NativeAppIconProps extends Omit<SvgWrapperProps, 'children'> {
  border?: boolean;
  className?: string;
  nativeAppId: number;
}

export const NativeAppIcon = ({
  border = false,
  className,
  nativeAppId,
  ...props
}: NativeAppIconProps) => {
  const IconComponent = NATIVE_APP_ICONS[nativeAppId];

  if (!IconComponent) {
    return null;
  }

  if (!border) {
    return (
      <IconComponent
        className={clsx('native-app-icon', className)}
        {...props}
      />
    );
  }

  return (
    <div className="native-app-icon native-app-icon--border">
      <IconComponent
        className={clsx('native-app-icon', className)}
        {...props}
      />
    </div>
  );
};
